import { render, staticRenderFns } from "./LegalRegulations.vue?vue&type=template&id=4d3fb0d2&"
import script from "./LegalRegulations.vue?vue&type=script&lang=js&"
export * from "./LegalRegulations.vue?vue&type=script&lang=js&"
import style0 from "./LegalRegulations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports